import { contracts, type Permission } from '@immo/api-contract';
import { mayCall } from '@/lib/permissions/route-gate';
import { apiClient } from './api-client';

export function canReadAllWorkspaceOrganizations(permissions: ReadonlyArray<Permission>): boolean {
  return mayCall(permissions, contracts.organizations.list);
}

export function canCreateWorkspaceOrganization(permissions: ReadonlyArray<Permission>): boolean {
  return mayCall(permissions, contracts.organizations.create);
}

/** Lists workspace organisations via the endpoint the caller is authorised for. */
export async function listWorkspaceOrganizations(workspaceId: string, permissions?: ReadonlyArray<Permission>) {
  if (permissions === undefined) {
    const full = await apiClient.organizations.list({ pathParams: { workspaceId } });

    if (full.ok || full.status !== 403) {
      return full;
    }

    return apiClient.organizations.listMine({ pathParams: { workspaceId } });
  }

  if (canReadAllWorkspaceOrganizations(permissions)) {
    return apiClient.organizations.list({ pathParams: { workspaceId } });
  }

  return apiClient.organizations.listMine({ pathParams: { workspaceId } });
}
